/**
 * AdventureBox — Wishlist (localStorage + GA4)
 * - Toggles heart state on .ab-card__wishlist buttons
 * - Persists product IDs in localStorage['ab_wishlist']
 * - Sends GA4 events: add_to_wishlist / remove_from_wishlist
 * - Updates header counter [data-ab-wishlist-count] if present
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ab_wishlist';
  var ACTIVE_CLASS = 'ab-card__wishlist--active';

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      // localStorage full or blocked — fail silently
    }
  }

  function updateCounter() {
    var nodes = document.querySelectorAll('[data-ab-wishlist-count]');
    if (!nodes.length) return;
    var count = getList().length;
    nodes.forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function syncOneButton(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var list = getList();
    var active = list.indexOf(id) !== -1;
    btn.classList.toggle(ACTIVE_CLASS, active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
  }

  function syncAllButtons() {
    document.querySelectorAll('.ab-card__wishlist').forEach(syncOneButton);
  }

  function sendGAEvent(action, productId, productTitle, productHandle) {
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', action, {
        items: [{
          item_id: productId,
          item_name: productTitle || '',
          item_brand: 'AdventureBox',
        }],
        currency: 'CAD',
      });
    } catch (e) { /* swallow */ }
  }

  function onClick(e) {
    var btn = e.target.closest('.ab-card__wishlist');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var title = btn.getAttribute('data-product-title') || '';
    var handle = btn.getAttribute('data-product-handle') || '';

    var list = getList();
    var idx = list.indexOf(id);
    var action;
    if (idx === -1) {
      list.push(id);
      action = 'add_to_wishlist';
    } else {
      list.splice(idx, 1);
      action = 'remove_from_wishlist';
    }
    saveList(list);

    // Sync ALL buttons for this product on the page (e.g. multiple grids)
    document.querySelectorAll('.ab-card__wishlist[data-product-id="' + CSS.escape(id) + '"]')
      .forEach(syncOneButton);
    updateCounter();
    sendGAEvent(action, id, title, handle);

    // Micro-feedback
    btn.classList.add('ab-card__wishlist--bump');
    setTimeout(function () { btn.classList.remove('ab-card__wishlist--bump'); }, 380);
  }

  function init() {
    syncAllButtons();
    updateCounter();
    document.addEventListener('click', onClick, { passive: false });
    // Sync across tabs
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) { syncAllButtons(); updateCounter(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
